var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAuthscreensBg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1728,
    height: 1117,
    viewBox: "0 0 1728 1117",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H1728V1117H0V0Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1697.18 267C1697.18 414.46 1577.64 534 1430.18 534C1282.72 534 1163.18 414.46 1163.18 267C1163.18 119.54 1282.72 0 1430.18 0C1577.64 0 1697.18 119.54 1697.18 267Z",
    fill: "#AAAAAA",
    fillOpacity: 0.09
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M717 179C717 277.859 636.859 358 538 358C439.141 358 359 277.859 359 179C359 80.141 439.141 0 538 0C636.859 0 717 80.141 717 179Z",
    fill: "#AAAAAA",
    fillOpacity: 0.09
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1157.36 661C1157.36 860.474 995.654 1022.18 796.18 1022.18C596.706 1022.18 435 860.474 435 661C435 461.526 596.706 299.82 796.18 299.82C995.654 299.82 1157.36 461.526 1157.36 661Z",
    fill: "#AAAAAA",
    fillOpacity: 0.09
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M810.99 1080C810.99 1100.43 794.429 1116.99 774 1116.99C753.571 1116.99 737.01 1100.43 737.01 1080C737.01 1059.57 753.571 1043.01 774 1043.01C794.429 1043.01 810.99 1059.57 810.99 1080Z",
    fill: "#AAAAAA",
    fillOpacity: 0.09
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M157.99 687C157.99 730.625 122.625 765.99 79 765.99C35.375 765.99 0.01 730.625 0.01 687C0.01 643.375 35.375 608.01 79 608.01C122.625 608.01 157.99 643.375 157.99 687Z",
    fill: "#AAAAAA",
    fillOpacity: 0.09
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1413.99 976C1413.99 1053.87 1350.87 1116.99 1273 1116.99C1195.13 1116.99 1132.01 1053.87 1132.01 976C1132.01 898.133 1195.13 835.01 1273 835.01C1350.87 835.01 1413.99 898.133 1413.99 976Z",
    fill: "#AAAAAA",
    fillOpacity: 0.09
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M974.99 115C974.99 178.507 923.507 229.99 860 229.99C796.493 229.99 745.01 178.507 745.01 115C745.01 51.4928 796.493 0.01 860 0.01C923.507 0.01 974.99 51.4928 974.99 115Z",
    fill: "#AAAAAA",
    fillOpacity: 0.09
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M61.99 119C61.99 136.115 48.1153 149.99 31 149.99C13.8847 149.99 0.01 136.115 0.01 119C0.01 101.885 13.8847 88.01 31 88.01C48.1153 88.01 61.99 101.885 61.99 119Z",
    fill: "#AAAAAA",
    fillOpacity: 0.09
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M428.44 629C428.44 660.723 402.723 686.44 371 686.44C339.277 686.44 313.56 660.723 313.56 629C313.56 597.277 339.277 571.56 371 571.56C402.723 571.56 428.44 597.277 428.44 629Z",
    fill: "#AAAAAA",
    fillOpacity: 0.09
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M1237.02 511C1237.02 539.73 1213.73 563.02 1185 563.02C1156.27 563.02 1132.98 539.73 1132.98 511C1132.98 482.27 1156.27 458.98 1185 458.98C1213.73 458.98 1237.02 482.27 1237.02 511Z",
    fill: "#AAAAAA",
    fillOpacity: 0.09
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M177.99 910C177.99 959.148 138.148 998.99 89 998.99C39.8522 998.99 0.01 959.148 0.01 910C0.01 860.852 39.8522 821.01 89 821.01C138.148 821.01 177.99 860.852 177.99 910Z",
    fill: "#AAAAAA",
    fillOpacity: 0.09
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M1073.43 113C1073.43 138.643 1052.64 159.43 1027 159.43C1001.36 159.43 980.57 138.643 980.57 113C980.57 87.3574 1001.36 66.57 1027 66.57C1052.64 66.57 1073.43 87.3574 1073.43 113Z",
    fill: "#AAAAAA",
    fillOpacity: 0.09
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M326.31 689C326.31 713.472 306.472 733.31 282 733.31C257.528 733.31 237.69 713.472 237.69 689C237.69 664.528 257.528 644.69 282 644.69C306.472 644.69 326.31 664.528 326.31 689Z",
    fill: "#AAAAAA",
    fillOpacity: 0.09
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M1191.05 117C1191.05 147.956 1165.96 173.05 1135 173.05C1104.04 173.05 1078.95 147.956 1078.95 117C1078.95 86.0444 1104.04 60.95 1135 60.95C1165.96 60.95 1191.05 86.0444 1191.05 117Z",
    fill: "#AAAAAA",
    fillOpacity: 0.09
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M329.28 557C329.28 595.262 298.262 626.28 260 626.28C221.738 626.28 190.72 595.262 190.72 557C190.72 518.738 221.738 487.72 260 487.72C298.262 487.72 329.28 518.738 329.28 557Z",
    fill: "#AAAAAA",
    fillOpacity: 0.09
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M392.88 318C392.88 362.117 357.117 397.88 313 397.88C268.883 397.88 233.12 362.117 233.12 318C233.12 273.883 268.883 238.12 313 238.12C357.117 238.12 392.88 273.883 392.88 318Z",
    fill: "#AAAAAA",
    fillOpacity: 0.09
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M1655 1065C1655 1093.72 1631.72 1117 1603 1117C1574.28 1117 1551 1093.72 1551 1065C1551 1036.28 1574.28 1013 1603 1013C1631.72 1013 1655 1036.28 1655 1065Z",
    fill: "#AAAAAA",
    fillOpacity: 0.09
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M415.01 525C415.01 547.649 396.649 566.01 374 566.01C351.351 566.01 332.99 547.649 332.99 525C332.99 502.351 351.351 483.99 374 483.99C396.649 483.99 415.01 502.351 415.01 525Z",
    fill: "#AAAAAA",
    fillOpacity: 0.09
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M603.84 991C603.84 1007.48 590.48 1020.84 574 1020.84C557.52 1020.84 544.16 1007.48 544.16 991C544.16 974.52 557.52 961.16 574 961.16C590.48 961.16 603.84 974.52 603.84 991Z",
    fill: "#AAAAAA",
    fillOpacity: 0.09
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M1122.64 211C1122.64 240.072 1099.07 263.64 1070 263.64C1040.93 263.64 1017.36 240.072 1017.36 211C1017.36 181.928 1040.93 158.36 1070 158.36C1099.07 158.36 1122.64 181.928 1122.64 211Z",
    fill: "#AAAAAA",
    fillOpacity: 0.09
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M173.29 534C173.29 572.82 141.82 604.29 103 604.29C64.1799 604.29 32.71 572.82 32.71 534C32.71 495.18 64.1799 463.71 103 463.71C141.82 463.71 173.29 495.18 173.29 534Z",
    fill: "#AAAAAA",
    fillOpacity: 0.09
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M1727.99 814C1727.99 876.955 1676.95 927.99 1614 927.99C1551.05 927.99 1500.01 876.955 1500.01 814C1500.01 751.045 1551.05 700.01 1614 700.01C1676.95 700.01 1727.99 751.045 1727.99 814Z",
    fill: "#AAAAAA",
    fillOpacity: 0.09
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M1539 1065C1539 1093.72 1515.72 1117 1487 1117C1458.28 1117 1435 1093.72 1435 1065C1435 1036.28 1458.28 1013 1487 1013C1515.72 1013 1539 1036.28 1539 1065Z",
    fill: "#AAAAAA",
    fillOpacity: 0.09
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M376.57 77C376.57 105.481 353.481 128.57 325 128.57C296.519 128.57 273.43 105.481 273.43 77C273.43 48.5187 296.519 25.43 325 25.43C353.481 25.43 376.57 48.5187 376.57 77Z",
    fill: "#AAAAAA",
    fillOpacity: 0.09
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M1430.14 622C1430.14 673.992 1387.99 716.14 1336 716.14C1284.01 716.14 1241.86 673.992 1241.86 622C1241.86 570.008 1284.01 527.86 1336 527.86C1387.99 527.86 1430.14 570.008 1430.14 622Z",
    fill: "#AAAAAA",
    fillOpacity: 0.09
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M1169.56 359C1169.56 377.535 1154.53 392.56 1136 392.56C1117.47 392.56 1102.44 377.535 1102.44 359C1102.44 340.465 1117.47 325.44 1136 325.44C1154.53 325.44 1169.56 340.465 1169.56 359Z",
    fill: "#AAAAAA",
    fillOpacity: 0.09
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M432.22 458C432.22 473.033 420.033 485.22 405 485.22C389.967 485.22 377.78 473.033 377.78 458C377.78 442.967 389.967 430.78 405 430.78C420.033 430.78 432.22 442.967 432.22 458Z",
    fill: "#AAAAAA",
    fillOpacity: 0.09
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M287.95 957C287.95 987.9 262.9 1012.95 232 1012.95C201.1 1012.95 176.05 987.9 176.05 957C176.05 926.1 201.1 901.05 232 901.05C262.9 901.05 287.95 926.1 287.95 957Z",
    fill: "#AAAAAA",
    fillOpacity: 0.09
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M1728 489C1728 512.196 1709.2 531 1686 531C1662.8 531 1644 512.196 1644 489C1644 465.804 1662.8 447 1686 447C1709.2 447 1728 465.804 1728 489Z",
    fill: "#AAAAAA",
    fillOpacity: 0.09
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M177.61 1054C177.61 1083.61 153.608 1107.61 124 1107.61C94.392 1107.61 70.39 1083.61 70.39 1054C70.39 1024.39 94.392 1000.39 124 1000.39C153.608 1000.39 177.61 1024.39 177.61 1054Z",
    fill: "#AAAAAA",
    fillOpacity: 0.09
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M287.99 1085C287.99 1102.67 273.668 1116.99 256 1116.99C238.332 1116.99 224.01 1102.67 224.01 1085C224.01 1067.33 238.332 1053.01 256 1053.01C273.668 1053.01 287.99 1067.33 287.99 1085Z",
    fill: "#AAAAAA",
    fillOpacity: 0.09
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M221.33 829C221.33 847.408 206.408 862.33 188 862.33C169.592 862.33 154.67 847.408 154.67 829C154.67 810.592 169.592 795.67 188 795.67C206.408 795.67 221.33 810.592 221.33 829Z",
    fill: "#AAAAAA",
    fillOpacity: 0.09
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M1206.24 689C1206.24 701.835 1195.84 712.24 1183 712.24C1170.16 712.24 1159.76 701.835 1159.76 689C1159.76 676.165 1170.16 665.76 1183 665.76C1195.84 665.76 1206.24 676.165 1206.24 689Z",
    fill: "#AAAAAA",
    fillOpacity: 0.09
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M1430.12 751C1430.12 773.158 1412.16 791.12 1390 791.12C1367.84 791.12 1349.88 773.158 1349.88 751C1349.88 728.842 1367.84 710.88 1390 710.88C1412.16 710.88 1430.12 728.842 1430.12 751Z",
    fill: "#AAAAAA",
    fillOpacity: 0.09
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M1727.99 1070C1727.99 1087.12 1714.12 1100.99 1697 1100.99C1679.88 1100.99 1666.01 1087.12 1666.01 1070C1666.01 1052.88 1679.88 1039.01 1697 1039.01C1714.12 1039.01 1727.99 1052.88 1727.99 1070Z",
    fill: "#AAAAAA",
    fillOpacity: 0.09
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M1550.16 574C1550.16 598.389 1530.39 618.16 1506 618.16C1481.61 618.16 1461.84 598.389 1461.84 574C1461.84 549.611 1481.61 529.84 1506 529.84C1530.39 529.84 1550.16 549.611 1550.16 574Z",
    fill: "#AAAAAA",
    fillOpacity: 0.09
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M84 221C84 244.196 65.196 263 42 263C18.804 263 0 244.196 0 221C0 197.804 18.804 179 42 179C65.196 179 84 197.804 84 221Z",
    fill: "#AAAAAA",
    fillOpacity: 0.09
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M1314.28 750C1314.28 774.455 1294.46 794.28 1270 794.28C1245.54 794.28 1225.72 774.455 1225.72 750C1225.72 725.545 1245.54 705.72 1270 705.72C1294.46 705.72 1314.28 725.545 1314.28 750Z",
    fill: "#AAAAAA",
    fillOpacity: 0.09
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M440.74 831C440.74 887.742 394.742 933.74 338 933.74C281.258 933.74 235.26 887.742 235.26 831C235.26 774.258 281.258 728.26 338 728.26C394.742 728.26 440.74 774.258 440.74 831Z",
    fill: "#AAAAAA",
    fillOpacity: 0.09
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M1512.42 983C1512.42 996.487 1501.49 1007.42 1488 1007.42C1474.51 1007.42 1463.58 996.487 1463.58 983C1463.58 969.513 1474.51 958.58 1488 958.58C1501.49 958.58 1512.42 969.513 1512.42 983Z",
    fill: "#AAAAAA",
    fillOpacity: 0.09
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M1011.78 212C1011.78 227.895 998.895 240.78 983 240.78C967.105 240.78 954.22 227.895 954.22 212C954.22 196.105 967.105 183.22 983 183.22C998.895 183.22 1011.78 196.105 1011.78 212Z",
    fill: "#AAAAAA",
    fillOpacity: 0.09
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M533.97 390C533.97 406 521 418.97 505 418.97C489 418.97 476.03 406 476.03 390C476.03 374 489 361.03 505 361.03C521 361.03 533.97 374 533.97 390Z",
    fill: "#AAAAAA",
    fillOpacity: 0.09
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M1480.76 633C1480.76 645.57 1470.57 655.76 1458 655.76C1445.43 655.76 1435.24 645.57 1435.24 633C1435.24 620.43 1445.43 610.24 1458 610.24C1470.57 610.24 1480.76 620.43 1480.76 633Z",
    fill: "#AAAAAA",
    fillOpacity: 0.09
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M472.98 988C472.98 1023.34 444.335 1051.98 409 1051.98C373.665 1051.98 345.02 1023.34 345.02 988C345.02 952.665 373.665 924.02 409 924.02C444.335 924.02 472.98 952.665 472.98 988Z",
    fill: "#AAAAAA",
    fillOpacity: 0.09
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M1126.43 978C1126.43 1008.06 1102.06 1032.43 1072 1032.43C1041.94 1032.43 1017.57 1008.06 1017.57 978C1017.57 947.939 1041.94 923.57 1072 923.57C1102.06 923.57 1126.43 947.939 1126.43 978Z",
    fill: "#AAAAAA",
    fillOpacity: 0.09
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M1498.74 778C1498.74 796.082 1484.08 810.74 1466 810.74C1447.92 810.74 1433.26 796.082 1433.26 778C1433.26 759.918 1447.92 745.26 1466 745.26C1484.08 745.26 1498.74 759.918 1498.74 778Z",
    fill: "#AAAAAA",
    fillOpacity: 0.09
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M1246.99 35C1246.99 54.3244 1231.32 69.99 1212 69.99C1192.68 69.99 1177.01 54.3244 1177.01 35C1177.01 15.6756 1192.68 0.01 1212 0.01C1231.32 0.01 1246.99 15.6756 1246.99 35Z",
    fill: "#AAAAAA",
    fillOpacity: 0.09
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M1531.74 912C1531.74 927.32 1519.32 939.74 1504 939.74C1488.68 939.74 1476.26 927.32 1476.26 912C1476.26 896.68 1488.68 884.26 1504 884.26C1519.32 884.26 1531.74 896.68 1531.74 912Z",
    fill: "#AAAAAA",
    fillOpacity: 0.09
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M1639.17 544C1639.17 568.394 1619.39 588.17 1595 588.17C1570.61 588.17 1550.83 568.394 1550.83 544C1550.83 519.606 1570.61 499.83 1595 499.83C1619.39 499.83 1639.17 519.606 1639.17 544Z",
    fill: "#AAAAAA",
    fillOpacity: 0.09
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M851.81 255C851.81 267.598 841.598 277.81 829 277.81C816.402 277.81 806.19 267.598 806.19 255C806.19 242.402 816.402 232.19 829 232.19C841.598 232.19 851.81 242.402 851.81 255Z",
    fill: "#AAAAAA",
    fillOpacity: 0.09
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M92 337C92 362.405 71.4051 383 46 383C20.5949 383 0 362.405 0 337C0 311.595 20.5949 291 46 291C71.4051 291 92 311.595 92 337Z",
    fill: "#AAAAAA",
    fillOpacity: 0.09
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M1470.7 914C1470.7 930.403 1457.4 943.7 1441 943.7C1424.6 943.7 1411.3 930.403 1411.3 914C1411.3 897.597 1424.6 884.3 1441 884.3C1457.4 884.3 1470.7 897.597 1470.7 914Z",
    fill: "#AAAAAA",
    fillOpacity: 0.09
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M1035.85 1039C1035.85 1055.49 1022.49 1068.85 1006 1068.85C989.514 1068.85 976.15 1055.49 976.15 1039C976.15 1022.51 989.514 1009.15 1006 1009.15C1022.49 1009.15 1035.85 1022.51 1035.85 1039Z",
    fill: "#AAAAAA",
    fillOpacity: 0.09
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M682 1041C682 1065.3 662.301 1085 638 1085C613.699 1085 594 1065.3 594 1041C594 1016.7 613.699 997 638 997C662.301 997 682 1016.7 682 1041Z",
    fill: "#AAAAAA",
    fillOpacity: 0.09
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M1727.99 411C1727.99 425.354 1716.35 436.99 1702 436.99C1687.65 436.99 1676.01 425.354 1676.01 411C1676.01 396.646 1687.65 385.01 1702 385.01C1716.35 385.01 1727.99 396.646 1727.99 411Z",
    fill: "#AAAAAA",
    fillOpacity: 0.09
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M1492.7 715C1492.7 728.641 1481.64 739.7 1468 739.7C1454.36 739.7 1443.3 728.641 1443.3 715C1443.3 701.359 1454.36 690.3 1468 690.3C1481.64 690.3 1492.7 701.359 1492.7 715Z",
    fill: "#AAAAAA",
    fillOpacity: 0.09
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M530.99 1092C530.99 1105.8 519.802 1116.99 506 1116.99C492.198 1116.99 481.01 1105.8 481.01 1092C481.01 1078.2 492.198 1067.01 506 1067.01C519.802 1067.01 530.99 1078.2 530.99 1092Z",
    fill: "#AAAAAA",
    fillOpacity: 0.09
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M234.68 273C234.68 305.96 207.96 332.68 175 332.68C142.04 332.68 115.32 305.96 115.32 273C115.32 240.04 142.04 213.32 175 213.32C207.96 213.32 234.68 240.04 234.68 273Z",
    fill: "#AAAAAA",
    fillOpacity: 0.09
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M1720.42 572C1720.42 591.562 1704.56 607.42 1685 607.42C1665.44 607.42 1649.58 591.562 1649.58 572C1649.58 552.438 1665.44 536.58 1685 536.58C1704.56 536.58 1720.42 552.438 1720.42 572Z",
    fill: "#AAAAAA",
    fillOpacity: 0.09
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M944.66 1065C944.66 1092.43 922.426 1114.66 895 1114.66C867.574 1114.66 845.34 1092.43 845.34 1065C845.34 1037.57 867.574 1015.34 895 1015.34C922.426 1015.34 944.66 1037.57 944.66 1065Z",
    fill: "#AAAAAA",
    fillOpacity: 0.09
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M343.29 1017C343.29 1036.49 327.49 1052.29 308 1052.29C288.51 1052.29 272.71 1036.49 272.71 1017C272.71 997.51 288.51 981.71 308 981.71C327.49 981.71 343.29 997.51 343.29 1017Z",
    fill: "#AAAAAA",
    fillOpacity: 0.09
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M130.54 136C130.54 153.971 115.971 168.54 98 168.54C80.0287 168.54 65.46 153.971 65.46 136C65.46 118.029 80.0287 103.46 98 103.46C115.971 103.46 130.54 118.029 130.54 136Z",
    fill: "#AAAAAA",
    fillOpacity: 0.09
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M769.19 267C769.19 284.226 755.226 298.19 738 298.19C720.774 298.19 706.81 284.226 706.81 267C706.81 249.774 720.774 235.81 738 235.81C755.226 235.81 769.19 249.774 769.19 267Z",
    fill: "#AAAAAA",
    fillOpacity: 0.09
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M86.68 42C86.68 65.0192 68.0192 83.68 45 83.68C21.9808 83.68 3.32 65.0192 3.32 42C3.32 18.9808 21.9808 0.32 45 0.32C68.0192 0.32 86.68 18.9808 86.68 42Z",
    fill: "#AAAAAA",
    fillOpacity: 0.09
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M293.1 149C293.1 181.088 267.088 207.1 235 207.1C202.912 207.1 176.9 181.088 176.9 149C176.9 116.912 202.912 90.9 235 90.9C267.088 90.9 293.1 116.912 293.1 149Z",
    fill: "#AAAAAA",
    fillOpacity: 0.09
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M755.34 48C755.34 63.6517 742.652 76.34 727 76.34C711.348 76.34 698.66 63.6517 698.66 48C698.66 32.3483 711.348 19.66 727 19.66C742.652 19.66 755.34 32.3483 755.34 48Z",
    fill: "#AAAAAA",
    fillOpacity: 0.09
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M1585.92 671C1585.92 691.943 1568.94 708.92 1548 708.92C1527.06 708.92 1510.08 691.943 1510.08 671C1510.08 650.057 1527.06 633.08 1548 633.08C1568.94 633.08 1585.92 650.057 1585.92 671Z",
    fill: "#AAAAAA",
    fillOpacity: 0.09
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M1148.66 298C1148.66 310.515 1138.51 320.66 1126 320.66C1113.49 320.66 1103.34 310.515 1103.34 298C1103.34 285.485 1113.49 275.34 1126 275.34C1138.51 275.34 1148.66 285.485 1148.66 298Z",
    fill: "#AAAAAA",
    fillOpacity: 0.09
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M210.27 763C210.27 778.061 198.061 790.27 183 790.27C167.939 790.27 155.73 778.061 155.73 763C155.73 747.939 167.939 735.73 183 735.73C198.061 735.73 210.27 747.939 210.27 763Z",
    fill: "#AAAAAA",
    fillOpacity: 0.09
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M488.7 871C488.7 883.537 478.537 893.7 466 893.7C453.463 893.7 443.3 883.537 443.3 871C443.3 858.463 453.463 848.3 466 848.3C478.537 848.3 488.7 858.463 488.7 871Z",
    fill: "#AAAAAA",
    fillOpacity: 0.09
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M1680.79 68C1680.79 83.348 1668.35 95.79 1653 95.79C1637.65 95.79 1625.21 83.348 1625.21 68C1625.21 52.652 1637.65 40.21 1653 40.21C1668.35 40.21 1680.79 52.652 1680.79 68Z",
    fill: "#AAAAAA",
    fillOpacity: 0.09
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M470.51 387C470.51 402.193 458.193 414.51 443 414.51C427.807 414.51 415.49 402.193 415.49 387C415.49 371.807 427.807 359.49 443 359.49C458.193 359.49 470.51 371.807 470.51 387Z",
    fill: "#AAAAAA",
    fillOpacity: 0.09
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M1151.77 424C1151.77 438.785 1139.78 450.77 1125 450.77C1110.22 450.77 1098.23 438.785 1098.23 424C1098.23 409.215 1110.22 397.23 1125 397.23C1139.78 397.23 1151.77 409.215 1151.77 424Z",
    fill: "#AAAAAA",
    fillOpacity: 0.09
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M1663.04 618C1663.04 631.277 1652.28 642.04 1639 642.04C1625.72 642.04 1614.96 631.277 1614.96 618C1614.96 604.723 1625.72 593.96 1639 593.96C1652.28 593.96 1663.04 604.723 1663.04 618Z",
    fill: "#AAAAAA",
    fillOpacity: 0.09
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M542.18 1025C542.18 1044.43 526.429 1060.18 507 1060.18C487.571 1060.18 471.82 1044.43 471.82 1025C471.82 1005.57 487.571 989.82 507 989.82C526.429 989.82 542.18 1005.57 542.18 1025Z",
    fill: "#AAAAAA",
    fillOpacity: 0.09
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M1097.99 23C1097.99 35.697 1087.7 45.99 1075 45.99C1062.3 45.99 1052.01 35.697 1052.01 23C1052.01 10.303 1062.3 0.01 1075 0.01C1087.7 0.01 1097.99 10.303 1097.99 23Z",
    fill: "#AAAAAA",
    fillOpacity: 0.09
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M195.99 36C195.99 55.8767 179.877 71.99 160 71.99C140.123 71.99 124.01 55.8767 124.01 36C124.01 16.1233 140.123 0.01 160 0.01C179.877 0.01 195.99 16.1233 195.99 36Z",
    fill: "#AAAAAA",
    fillOpacity: 0.09
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M323.93 440C323.93 462.053 306.053 479.93 284 479.93C261.947 479.93 244.07 462.053 244.07 440C244.07 417.947 261.947 400.07 284 400.07C306.053 400.07 323.93 417.947 323.93 440Z",
    fill: "#AAAAAA",
    fillOpacity: 0.09
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M169.07 421C169.07 443.13 151.13 461.07 129 461.07C106.87 461.07 88.93 443.13 88.93 421C88.93 398.87 106.87 380.93 129 380.93C151.13 380.93 169.07 398.87 169.07 421Z",
    fill: "#AAAAAA",
    fillOpacity: 0.09
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M935.76 286C935.76 300.227 924.227 311.76 910 311.76C895.773 311.76 884.24 300.227 884.24 286C884.24 271.773 895.773 260.24 910 260.24C924.227 260.24 935.76 271.773 935.76 286Z",
    fill: "#AAAAAA",
    fillOpacity: 0.09
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M1635.76 27C1635.76 41.7791 1623.78 53.76 1609 53.76C1594.22 53.76 1582.24 41.7791 1582.24 27C1582.24 12.2209 1594.22 0.24 1609 0.24C1623.78 0.24 1635.76 12.2209 1635.76 27Z",
    fill: "#AAAAAA",
    fillOpacity: 0.09
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M1113.99 1079C1113.99 1099.98 1096.98 1116.99 1076 1116.99C1055.02 1116.99 1038.01 1099.98 1038.01 1079C1038.01 1058.02 1055.02 1041.01 1076 1041.01C1096.98 1041.01 1113.99 1058.02 1113.99 1079Z",
    fill: "#AAAAAA",
    fillOpacity: 0.09
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M1625.77 977C1625.77 993.994 1611.99 1007.77 1595 1007.77C1578.01 1007.77 1564.23 993.994 1564.23 977C1564.23 960.006 1578.01 946.23 1595 946.23C1611.99 946.23 1625.77 960.006 1625.77 977Z",
    fill: "#AAAAAA",
    fillOpacity: 0.09
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M1044.98 279C1044.98 294.453 1032.45 306.98 1017 306.98C1001.55 306.98 989.02 294.453 989.02 279C989.02 263.547 1001.55 251.02 1017 251.02C1032.45 251.02 1044.98 263.547 1044.98 279Z",
    fill: "#AAAAAA",
    fillOpacity: 0.09
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M1385.24 821C1385.24 837.149 1372.15 850.24 1356 850.24C1339.85 850.24 1326.76 837.149 1326.76 821C1326.76 804.851 1339.85 791.76 1356 791.76C1372.15 791.76 1385.24 804.851 1385.24 821Z",
    fill: "#AAAAAA",
    fillOpacity: 0.09
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M198.75 364C198.75 378.221 187.221 389.75 173 389.75C158.779 389.75 147.25 378.221 147.25 364C147.25 349.779 158.779 338.25 173 338.25C187.221 338.25 198.75 349.779 198.75 364Z",
    fill: "#AAAAAA",
    fillOpacity: 0.09
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M61.99 1083C61.99 1100.12 48.1153 1113.99 31 1113.99C13.8847 1113.99 0.01 1100.12 0.01 1083C0.01 1065.88 13.8847 1052.01 31 1052.01C48.1153 1052.01 61.99 1065.88 61.99 1083Z",
    fill: "#AAAAAA",
    fillOpacity: 0.09
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M1727.99 28C1727.99 41.2493 1717.25 51.99 1704 51.99C1690.75 51.99 1680.01 41.2493 1680.01 28C1680.01 14.7507 1690.75 4.01 1704 4.01C1717.25 4.01 1727.99 14.7507 1727.99 28Z",
    fill: "#AAAAAA",
    fillOpacity: 0.09
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M1027.41 39C1027.41 53.5858 1015.59 65.41 1001 65.41C986.414 65.41 974.59 53.5858 974.59 39C974.59 24.4142 986.414 12.59 1001 12.59C1015.59 12.59 1027.41 24.4142 1027.41 39Z",
    fill: "#AAAAAA",
    fillOpacity: 0.09
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M1203.77 781C1203.77 797.994 1189.99 811.77 1173 811.77C1156.01 811.77 1142.23 797.994 1142.23 781C1142.23 764.006 1156.01 750.23 1173 750.23C1189.99 750.23 1203.77 764.006 1203.77 781Z",
    fill: "#AAAAAA",
    fillOpacity: 0.09
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M1455.58 839C1455.58 857.546 1440.55 872.58 1422 872.58C1403.45 872.58 1388.42 857.546 1388.42 839C1388.42 820.454 1403.45 805.42 1422 805.42C1440.55 805.42 1455.58 820.454 1455.58 839Z",
    fill: "#AAAAAA",
    fillOpacity: 0.09
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M353.5 185C353.5 198.531 342.531 209.5 329 209.5C315.469 209.5 304.5 198.531 304.5 185C304.5 171.469 315.469 160.5 329 160.5C342.531 160.5 353.5 171.469 353.5 185Z",
    fill: "#AAAAAA",
    fillOpacity: 0.09
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M1709.12 952C1709.12 969.739 1694.74 984.12 1677 984.12C1659.26 984.12 1644.88 969.739 1644.88 952C1644.88 934.261 1659.26 919.88 1677 919.88C1694.74 919.88 1709.12 934.261 1709.12 952Z",
    fill: "#AAAAAA",
    fillOpacity: 0.09
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M57.99 799C57.99 815.011 45.0107 827.99 29 827.99C12.9893 827.99 0.01 815.011 0.01 799C0.01 782.989 12.9893 770.01 29 770.01C45.0107 770.01 57.99 782.989 57.99 799Z",
    fill: "#AAAAAA",
    fillOpacity: 0.09
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M1236.82 610C1236.82 627.574 1222.57 641.82 1205 641.82C1187.43 641.82 1173.18 627.574 1173.18 610C1173.18 592.426 1187.43 578.18 1205 578.18C1222.57 578.18 1236.82 592.426 1236.82 610Z",
    fill: "#AAAAAA",
    fillOpacity: 0.09
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M219.56 671C219.56 686.773 206.773 699.56 191 699.56C175.227 699.56 162.44 686.773 162.44 671C162.44 655.227 175.227 642.44 191 642.44C206.773 642.44 219.56 655.227 219.56 671Z",
    fill: "#AAAAAA",
    fillOpacity: 0.09
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M254.95 394C254.95 408.884 242.884 420.95 228 420.95C213.116 420.95 201.05 408.884 201.05 394C201.05 379.116 213.116 367.05 228 367.05C242.884 367.05 254.95 379.116 254.95 394Z",
    fill: "#AAAAAA",
    fillOpacity: 0.09
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M1101.56 394C1101.56 406.46 1091.46 416.56 1079 416.56C1066.54 416.56 1056.44 406.46 1056.44 394C1056.44 381.54 1066.54 371.44 1079 371.44C1091.46 371.44 1101.56 381.54 1101.56 394Z",
    fill: "#AAAAAA",
    fillOpacity: 0.09
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M83.37 419C83.37 434.116 71.116 446.37 56 446.37C40.884 446.37 28.63 434.116 28.63 419C28.63 403.884 40.884 391.63 56 391.63C71.116 391.63 83.37 403.884 83.37 419Z",
    fill: "#AAAAAA",
    fillOpacity: 0.09
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M405.99 1092C405.99 1105.8 394.802 1116.99 381 1116.99C367.198 1116.99 356.01 1105.8 356.01 1092C356.01 1078.2 367.198 1067.01 381 1067.01C394.802 1067.01 405.99 1078.2 405.99 1092Z",
    fill: "#AAAAAA",
    fillOpacity: 0.09
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M1140.73 890C1140.73 904.763 1128.76 916.73 1114 916.73C1099.24 916.73 1087.27 904.763 1087.27 890C1087.27 875.237 1099.24 863.27 1114 863.27C1128.76 863.27 1140.73 875.237 1140.73 890Z",
    fill: "#AAAAAA",
    fillOpacity: 0.09
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M583 1094C583 1106.7 572.703 1117 560 1117C547.297 1117 537 1106.7 537 1094C537 1081.3 547.297 1071 560 1071C572.703 1071 583 1081.3 583 1094Z",
    fill: "#AAAAAA",
    fillOpacity: 0.09
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M1725.31 674C1725.31 695.158 1708.16 712.31 1687 712.31C1665.84 712.31 1648.69 695.158 1648.69 674C1648.69 652.842 1665.84 635.69 1687 635.69C1708.16 635.69 1725.31 652.842 1725.31 674Z",
    fill: "#AAAAAA",
    fillOpacity: 0.09
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M1165.5 30C1165.5 44.0833 1154.08 55.5 1140 55.5C1125.92 55.5 1114.5 44.0833 1114.5 30C1114.5 15.9167 1125.92 4.5 1140 4.5C1154.08 4.5 1165.5 15.9167 1165.5 30Z",
    fill: "#AAAAAA",
    fillOpacity: 0.09
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M380.95 428C380.95 440.675 370.675 450.95 358 450.95C345.325 450.95 335.05 440.675 335.05 428C335.05 415.325 345.325 405.05 358 405.05C370.675 405.05 380.95 415.325 380.95 428Z",
    fill: "#AAAAAA",
    fillOpacity: 0.09
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M1726.22 158C1726.22 170.824 1715.82 181.22 1703 181.22C1690.18 181.22 1679.78 170.824 1679.78 158C1679.78 145.176 1690.18 134.78 1703 134.78C1715.82 134.78 1726.22 145.176 1726.22 158Z",
    fill: "#AAAAAA",
    fillOpacity: 0.09
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M536.35 959C536.35 973 525 984.35 511 984.35C497 984.35 485.65 973 485.65 959C485.65 945 497 933.65 511 933.65C525 933.65 536.35 945 536.35 959Z",
    fill: "#AAAAAA",
    fillOpacity: 0.09
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M1190.94 841C1190.94 854.222 1180.22 864.94 1167 864.94C1153.78 864.94 1143.06 854.222 1143.06 841C1143.06 827.778 1153.78 817.06 1167 817.06C1180.22 817.06 1190.94 827.778 1190.94 841Z",
    fill: "#AAAAAA",
    fillOpacity: 0.09
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M1097.79 296C1097.79 308.587 1087.59 318.79 1075 318.79C1062.41 318.79 1052.21 308.587 1052.21 296C1052.21 283.413 1062.41 273.21 1075 273.21C1087.59 273.21 1097.79 283.413 1097.79 296Z",
    fill: "#AAAAAA",
    fillOpacity: 0.09
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M272.28 49C272.28 67.38 257.38 82.28 239 82.28C220.62 82.28 205.72 67.38 205.72 49C205.72 30.62 220.62 15.72 239 15.72C257.38 15.72 272.28 30.62 272.28 49Z",
    fill: "#AAAAAA",
    fillOpacity: 0.09
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M770.89 207C770.89 220.194 760.194 230.89 747 230.89C733.806 230.89 723.11 220.194 723.11 207C723.11 193.806 733.806 183.11 747 183.11C760.194 183.11 770.89 193.806 770.89 207Z",
    fill: "#AAAAAA",
    fillOpacity: 0.09
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M230.75 468C230.75 487.192 215.192 502.75 196 502.75C176.808 502.75 161.25 487.192 161.25 468C161.25 448.808 176.808 433.25 196 433.25C215.192 433.25 230.75 448.808 230.75 468Z",
    fill: "#AAAAAA",
    fillOpacity: 0.09
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M152.36 781C152.36 793.349 142.349 803.36 130 803.36C117.651 803.36 107.64 793.349 107.64 781C107.64 768.651 117.651 758.64 130 758.64C142.349 758.64 152.36 768.651 152.36 781Z",
    fill: "#AAAAAA",
    fillOpacity: 0.09
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M1562.1 957C1562.1 969.758 1551.76 980.1 1539 980.1C1526.24 980.1 1515.9 969.758 1515.9 957C1515.9 944.242 1526.24 933.9 1539 933.9C1551.76 933.9 1562.1 944.242 1562.1 957Z",
    fill: "#AAAAAA",
    fillOpacity: 0.09
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M1170.49 1091C1170.49 1105.08 1159.08 1116.49 1145 1116.49C1130.92 1116.49 1119.51 1105.08 1119.51 1091C1119.51 1076.92 1130.92 1065.51 1145 1065.51C1159.08 1065.51 1170.49 1076.92 1170.49 1091Z",
    fill: "#AAAAAA",
    fillOpacity: 0.09
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M480.65 1069C480.65 1081.51 470.509 1091.65 458 1091.65C445.491 1091.65 435.35 1081.51 435.35 1069C435.35 1056.49 445.491 1046.35 458 1046.35C470.509 1046.35 480.65 1056.49 480.65 1069Z",
    fill: "#AAAAAA",
    fillOpacity: 0.09
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M163.58 192C163.58 204.471 153.471 214.58 141 214.58C128.529 214.58 118.42 204.471 118.42 192C118.42 179.529 128.529 169.42 141 169.42C153.471 169.42 163.58 179.529 163.58 192Z",
    fill: "#AAAAAA",
    fillOpacity: 0.09
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M1067.06 339C1067.06 353.945 1054.94 366.06 1040 366.06C1025.06 366.06 1012.94 353.945 1012.94 339C1012.94 324.055 1025.06 311.94 1040 311.94C1054.94 311.94 1067.06 324.055 1067.06 339Z",
    fill: "#AAAAAA",
    fillOpacity: 0.09
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M735.93 1043C735.93 1056.22 725.216 1066.93 712 1066.93C698.784 1066.93 688.07 1056.22 688.07 1043C688.07 1029.78 698.784 1019.07 712 1019.07C725.216 1019.07 735.93 1029.78 735.93 1043Z",
    fill: "#AAAAAA",
    fillOpacity: 0.09
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M57.77 1016C57.77 1030.23 46.2324 1041.77 32 1041.77C17.7676 1041.77 6.23 1030.23 6.23 1016C6.23 1001.77 17.7676 990.23 32 990.23C46.2324 990.23 57.77 1001.77 57.77 1016Z",
    fill: "#AAAAAA",
    fillOpacity: 0.09
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M348.43 1086C348.43 1101.15 336.149 1113.43 321 1113.43C305.851 1113.43 293.57 1101.15 293.57 1086C293.57 1070.85 305.851 1058.57 321 1058.57C336.149 1058.57 348.43 1070.85 348.43 1086Z",
    fill: "#AAAAAA",
    fillOpacity: 0.09
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M1431.41 1083C1431.41 1096.48 1420.48 1107.41 1407 1107.41C1393.52 1107.41 1382.59 1096.48 1382.59 1083C1382.59 1069.52 1393.52 1058.59 1407 1058.59C1420.48 1058.59 1431.41 1069.52 1431.41 1083Z",
    fill: "#AAAAAA",
    fillOpacity: 0.09
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M1688.84 1015C1688.84 1027.61 1678.61 1037.84 1666 1037.84C1653.39 1037.84 1643.16 1027.61 1643.16 1015C1643.16 1002.39 1653.39 992.16 1666 992.16C1678.61 992.16 1688.84 1002.39 1688.84 1015Z",
    fill: "#AAAAAA",
    fillOpacity: 0.09
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M1248.93 808C1248.93 820.664 1238.66 830.93 1226 830.93C1213.34 830.93 1203.07 820.664 1203.07 808C1203.07 795.336 1213.34 785.07 1226 785.07C1238.66 785.07 1248.93 795.336 1248.93 808Z",
    fill: "#AAAAAA",
    fillOpacity: 0.09
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M993.99 1093C993.99 1106.25 983.249 1116.99 970 1116.99C956.751 1116.99 946.01 1106.25 946.01 1093C946.01 1079.75 956.751 1069.01 970 1069.01C983.249 1069.01 993.99 1079.75 993.99 1093Z",
    fill: "#AAAAAA",
    fillOpacity: 0.09
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M990.87 307C990.87 319.631 980.631 329.87 968 329.87C955.369 329.87 945.13 319.631 945.13 307C945.13 294.369 955.369 284.13 968 284.13C980.631 284.13 990.87 294.369 990.87 307Z",
    fill: "#AAAAAA",
    fillOpacity: 0.09
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M713.95 1093C713.95 1106.23 703.227 1116.95 690 1116.95C676.773 1116.95 666.05 1106.23 666.05 1093C666.05 1079.77 676.773 1069.05 690 1069.05C703.227 1069.05 713.95 1079.77 713.95 1093Z",
    fill: "#AAAAAA",
    fillOpacity: 0.09
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M1287.49 515C1287.49 527.421 1277.42 537.49 1265 537.49C1252.58 537.49 1242.51 527.421 1242.51 515C1242.51 502.579 1252.58 492.51 1265 492.51C1277.42 492.51 1287.49 502.579 1287.49 515Z",
    fill: "#AAAAAA",
    fillOpacity: 0.09
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M229.29 1045C229.29 1057.86 218.863 1068.29 206 1068.29C193.137 1068.29 182.71 1057.86 182.71 1045C182.71 1032.14 193.137 1021.71 206 1021.71C218.863 1021.71 229.29 1032.14 229.29 1045Z",
    fill: "#AAAAAA",
    fillOpacity: 0.09
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M430.45 711C430.45 723.951 419.951 734.45 407 734.45C394.049 734.45 383.55 723.951 383.55 711C383.55 698.049 394.049 687.55 407 687.55C419.951 687.55 430.45 698.049 430.45 711Z",
    fill: "#AAAAAA",
    fillOpacity: 0.09
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M1202.97 430C1202.97 442.686 1192.69 452.97 1180 452.97C1167.31 452.97 1157.03 442.686 1157.03 430C1157.03 417.314 1167.31 407.03 1180 407.03C1192.69 407.03 1202.97 417.314 1202.97 430Z",
    fill: "#AAAAAA",
    fillOpacity: 0.09
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M259.72 746C259.72 758.548 249.548 768.72 237 768.72C224.452 768.72 214.28 758.548 214.28 746C214.28 733.452 224.452 723.28 237 723.28C249.548 723.28 259.72 733.452 259.72 746Z",
    fill: "#AAAAAA",
    fillOpacity: 0.09
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M487.91 440C487.91 453.205 477.205 463.91 464 463.91C450.795 463.91 440.09 453.205 440.09 440C440.09 426.795 450.795 416.09 464 416.09C477.205 416.09 487.91 426.795 487.91 440Z",
    fill: "#AAAAAA",
    fillOpacity: 0.09
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M1724.76 99C1724.76 112.122 1714.12 122.76 1701 122.76C1687.88 122.76 1677.24 112.122 1677.24 99C1677.24 85.8777 1687.88 75.24 1701 75.24C1714.12 75.24 1724.76 85.8777 1724.76 99Z",
    fill: "#AAAAAA",
    fillOpacity: 0.09
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M1638.5 670C1638.5 682.979 1627.98 693.5 1615 693.5C1602.02 693.5 1591.5 682.979 1591.5 670C1591.5 657.021 1602.02 646.5 1615 646.5C1627.98 646.5 1638.5 657.021 1638.5 670Z",
    fill: "#AAAAAA",
    fillOpacity: 0.09
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M143.08 347C143.08 359.747 132.747 370.08 120 370.08C107.253 370.08 96.92 359.747 96.92 347C96.92 334.253 107.253 323.92 120 323.92C132.747 323.92 143.08 334.253 143.08 347Z",
    fill: "#AAAAAA",
    fillOpacity: 0.09
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M186.32 613C186.32 625.879 175.879 636.32 163 636.32C150.121 636.32 139.68 625.879 139.68 613C139.68 600.121 150.121 589.68 163 589.68C175.879 589.68 186.32 600.121 186.32 613Z",
    fill: "#AAAAAA",
    fillOpacity: 0.09
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M182.74 105C182.74 119.768 170.768 131.74 156 131.74C141.232 131.74 129.26 119.768 129.26 105C129.26 90.2319 141.232 78.26 156 78.26C170.768 78.26 182.74 90.2319 182.74 105Z",
    fill: "#AAAAAA",
    fillOpacity: 0.09
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M414.99 23C414.99 35.697 404.697 45.99 392 45.99C379.303 45.99 369.01 35.697 369.01 23C369.01 10.303 379.303 0.01 392 0.01C404.697 0.01 414.99 10.303 414.99 23Z",
    fill: "#AAAAAA",
    fillOpacity: 0.09
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M49.84 471C49.84 483.614 39.6142 493.84 27 493.84C14.3858 493.84 4.16 483.614 4.16 471C4.16 458.386 14.3858 448.16 27 448.16C39.6142 448.16 49.84 458.386 49.84 471Z",
    fill: "#AAAAAA",
    fillOpacity: 0.09
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M45.35 591C45.35 603.344 35.3436 613.35 23 613.35C10.6564 613.35 0.65 603.344 0.65 591C0.65 578.656 10.6564 568.65 23 568.65C35.3436 568.65 45.35 578.656 45.35 591Z",
    fill: "#AAAAAA",
    fillOpacity: 0.09
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M131.62 75C131.62 87.4927 121.493 97.62 109 97.62C96.5073 97.62 86.38 87.4927 86.38 75C86.38 62.5073 96.5073 52.38 109 52.38C121.493 52.38 131.62 62.5073 131.62 75Z",
    fill: "#AAAAAA",
    fillOpacity: 0.09
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M696.37 23C696.37 35.3546 686.355 45.37 674 45.37C661.645 45.37 651.63 35.3546 651.63 23C651.63 10.6454 661.645 0.63 674 0.63C686.355 0.63 696.37 10.6454 696.37 23Z",
    fill: "#AAAAAA",
    fillOpacity: 0.09
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M1567.47 1008C1567.47 1020.41 1557.41 1030.47 1545 1030.47C1532.59 1030.47 1522.53 1020.41 1522.53 1008C1522.53 995.59 1532.59 985.53 1545 985.53C1557.41 985.53 1567.47 995.59 1567.47 1008Z",
    fill: "#AAAAAA",
    fillOpacity: 0.09
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuthscreensBg);
export default __webpack_public_path__ + "static/media/authscreens_bg.9d20182204c71aaaa036be1aeb389e9c.svg";
export { ForwardRef as ReactComponent };